<template>
  <div class="dev-blog">
    <div class="center">
      <h1 class="coming-soon">COMING SOON</h1>
    </div>
    <!--
      TODO:
      - Load articles
        - title
        - htmlsafe imported from database
    -->
  </div>
</template>

<script>
export default {
  name: 'home-page',
  components: {
  },
  data () {
    return {
    }
  },
  methods: {

  },
  mounted () {

  }
}
</script>

<style lang="scss" scoped>
.dev-blog {
  height: 100%;
}

.center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.coming-soon {
  font-size: 48px;
  letter-spacing: 20px;
  font-weight: 700;
  line-height: 1.5;
  text-align: center;
  transition: all .3s ease;
  text-shadow: 0px 2px 2px rgba(0, 0, 0, .5);
  opacity: 0;
  transform: scale(.7);
  animation: appear 1s ease 1s forwards;

  @media screen and (max-width: 640px) {
    font-size: 24px;
    letter-spacing: 15px;
  }

  @keyframes appear {
    0% {
      opacity: 0;
      transform: scale(.7);
    }
    100% {
      opacity: 1;
      transform: scale(1);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dev-blog.vue